module.exports = __webpack_public_path__ + "static/img/fiveoff7.29b1f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fiveoff7.png
// module id = izsd
// module chunks = 0